import React from 'react';

import { useMedia } from 'react-use';

import * as S from './styles';

import { breakpointTo, bpMedium } from 'tokens';

interface ITooptip {
  label: string;
  position?: string;
  color?: string;
  icon?: JSX.Element;
}

interface IProps {
  color?: string;
}

const TooltipInfo: React.FC<ITooptip> = ({ label, position, color, icon }) => {
  const isMobile = useMedia(breakpointTo(bpMedium));

  const props: IProps = {};

  if (color) props.color = color;

  return (
    <span
      aria-label={label}
      className="ods-tooltip"
      data-tooltip-pos={position || isMobile ? 'right' : 'up'}
    >
      {icon ? icon : <S.CustomIcon style={{ ...props }} />}
    </span>
  );
};

export default TooltipInfo;
